export const InvestmentKey = {
  EQUITY_SHARES: 'sharesPercentage',
  HOLDING_NAME: 'name',
  HOLDING_TYPE: 'type',
  EMISSION: 'totalEmissions'
};

export const InvestmentLabel = {
  EQUITY_SHARES: 'Holding Percent',
  HOLDING_NAME: 'Holding Name',
  HOLDING_TYPE: 'Holding Type',
  EMISSION: 'Total Emissions'
};
